/** @format */

import RefreshIcon from '@mui/icons-material/Refresh';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from '../../theme';
import {
  clearChunkReloadFlag,
  isChunkLoadError,
} from '../../utils/lazyWithRetry';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (!isChunkLoadError(error)) {
      console.error('ChunkErrorBoundary caught an error:', error, errorInfo);
    }
  }

  handleRetry = () => {
    clearChunkReloadFlag();
    window.location.reload();
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ThemeProvider>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="50vh"
            p={3}
          >
            <Paper
              elevation={2}
              sx={{
                p: 4,
                maxWidth: 500,
                textAlign: 'center',
                borderRadius: 3,
                background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
              }}
            >
              <Box sx={{ mb: 2 }}>
                <CircularProgress
                  size={48}
                  thickness={4}
                  sx={{ color: 'primary.main' }}
                />
              </Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: 'primary.main', fontWeight: 600 }}
              >
                Mise à jour des composants
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{ color: 'text.secondary' }}
              >
                Une nouvelle version de l&apos;application est disponible.
                Veuillez actualiser la page pour profiter des dernières
                améliorations.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleRetry}
                size="large"
                startIcon={<RefreshIcon />}
                sx={{ borderRadius: 1 }}
              >
                Actualiser
              </Button>
            </Paper>
          </Box>
        </ThemeProvider>
      );
    }

    return children;
  }
}

ChunkErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChunkErrorBoundary;
